import {ChangeDetectorRef, OnDestroy, Pipe, PipeTransform} from '@angular/core';
import {Subscription} from 'rxjs';
import {TranslateModel} from '../models/translate.model';
import {TranslationService} from '../../../../provider/translation.service';

@Pipe({
  name: 'CaptionMlPipe',
  pure: false
})
export class CaptionMlPipe implements OnDestroy, PipeTransform {
  private lng = '';
  private subscription: Subscription;

  constructor(private tra: TranslationService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
    this.lng = this.tra.getSelectedLanguage();
    this.subscription = this.tra.language_change$.subscribe((val) => {
      this.lng = val;
      this.changeDetectorRef.markForCheck();
    });
  }


  transform(value: any, language?: string): string {
    try {
      let translateModel: TranslateModel;
      translateModel = JSON.parse(value);
      if (translateModel) {
        switch (this.lng) {
          case  'tr':
            if (translateModel.tr) {
              return translateModel.tr;
            } else {
              return translateModel.en;
            }
          case 'en':
            return translateModel.en;
          case  'ru':
            if (translateModel.ru) {
              return translateModel.ru;
            } else {
              return translateModel.en;
            }
          case  'fr':
            if (translateModel.fr) {
              return translateModel.fr;
            } else {
              return translateModel.en;
            }
          case  'de':
            if (translateModel.de) {
              return translateModel.de;
            } else {
              return translateModel.en;
            }
          case  'ar':
            if (translateModel.ar) {
              return translateModel.ar;
            } else {
              return translateModel.en;
            }
          case  'fa':
            if (translateModel.fa) {
              return translateModel.fa;
            } else {
              return translateModel.en;
            }
          default:
            return translateModel.en;
        }
      }
    } catch (e) {
      return value;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = void 0;
  }
}
